export default {
    LOADING: 'LOADING',
    FINISHED_LOADING: 'FINISHED_LOADING',
    FETCH_IMAGES: 'FETCH_IMAGES',
    FETCH_SPECIFIC_IMAGES: 'FETCH_SPECIFIC_IMAGES',
    DELETE_IMAGE: 'DELETE_IMAGE',
    SET_MODAL_IMAGE: 'SET_MODAL_IMAGE',
    UPDATE_IMAGE: 'UPDATE_IMAGE',
    LIKE_IMAGE: 'LIKE_IMAGE',
    UPLOADED_IMAGE: 'UPLOADED_IMAGE',
    ADD_COMMENT: 'ADD_COMMENT',
    SEARCH: 'SEARCH'
};
